import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';
import {setTokens} from 'shared/api/auth';

import ILoginForm from '../forms/ILoginForm';

export const loginUser = createAsyncThunk<void, ILoginForm>(
    'auth/loginUser',
    async(data) => {
        const response = await createHttpRequest({
            method: 'POST',
            path: ApiUrls.TOKEN,
            data: data,
            isAnonymous: true,
            errorMessage: t`Ошибка авторизации`,
        });
        setTokens(response.data);
    },
);
